import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Award, X } from "lucide-react";
import { useBranding } from "@/lib/branding";

const API = process.env.REACT_APP_BACKEND_URL;

export default function VerifyCertificate() {
  const { certId } = useParams();
  const { branding } = useBranding();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/afsp/verify/${certId}`)
      .then((r) => setCert(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Certificate not found"))
      .finally(() => setLoading(false));
  }, [certId]);

  return (
    <div className="min-h-screen bg-background grid place-items-center p-6" data-testid="verify-cert-page">
      <Card className="max-w-lg w-full p-8 text-center">
        {loading ? (
          <p className="text-muted-foreground">Verifying certificate…</p>
        ) : cert && cert.valid ? (
          <>
            <div className="mx-auto h-16 w-16 rounded-full bg-emerald-500/15 text-emerald-600 grid place-items-center mb-4">
              <Check size={30} strokeWidth={3} />
            </div>
            <div className="label-caps mb-2 text-emerald-600">Certificate Verified</div>
            <h1 className="font-serif text-4xl mb-2" data-testid="verify-cert-name">{cert.user_name}</h1>
            <p className="text-muted-foreground mb-6">
              passed the AFTR Practice Examination administered by{" "}
              <strong className="text-foreground">{branding.brand_name || "DyNamic Tax"}</strong>.
            </p>
            <div className="grid grid-cols-3 gap-3 mb-6">
              <div className="p-3 rounded-md border border-border">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Score</div>
                <div className="font-serif text-2xl">{cert.score}/{cert.total}</div>
              </div>
              <div className="p-3 rounded-md border border-border">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Percent</div>
                <div className="font-serif text-2xl text-primary">{cert.percent}%</div>
              </div>
              <div className="p-3 rounded-md border border-border">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Issued</div>
                <div className="font-serif text-base leading-tight mt-1">{new Date(cert.issued_at).toLocaleDateString()}</div>
              </div>
            </div>
            <div className="text-xs text-muted-foreground mb-4">
              Certificate ID · <span className="font-mono text-foreground" data-testid="verify-cert-id">{cert.cert_id}</span>
            </div>
            <Button asChild variant="outline" className="w-full">
              <Link to="/afsp-bundle">Learn about the AFSP Prep Bundle</Link>
            </Button>
          </>
        ) : (
          <>
            <div className="mx-auto h-16 w-16 rounded-full bg-destructive/15 text-destructive grid place-items-center mb-4">
              <X size={30} strokeWidth={3} />
            </div>
            <h1 className="font-serif text-3xl mb-2">Not verified</h1>
            <p className="text-muted-foreground mb-6">{error || "This certificate ID could not be matched."}</p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/">Back to home</Link>
            </Button>
          </>
        )}
      </Card>
    </div>
  );
}
